"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _EmbedModalV = _interopRequireDefault(require("rich-text-lib/components/EmbedModalV2"));

var _embedSrc = require("rich-text-lib/utils/embedSrc");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _default = (0, _createReactClass.default)({
  displayName: "AddEmbedButton",
  propTypes: {
    onChange: _propTypes.default.func.isRequired,
    useUnstyledButton: _propTypes.default.bool.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      showAddEmbedModal: false
    };
  },
  handleOpenModal: function handleOpenModal() {
    this.setState({
      showAddEmbedModal: true
    });
  },
  handleAddEmbed: function handleAddEmbed(modalData) {
    var embedData = (0, _embedSrc.getEmbedData)(modalData);

    if (embedData && embedData.length > 0) {
      this.props.onChange(embedData);
    }

    this.handleCloseModal();
  },
  handleCloseModal: function handleCloseModal(e) {
    if (e) {
      e.stopPropagation();
    }

    this.setState({
      showAddEmbedModal: false
    });
  },
  renderModal: function renderModal(showAddEmbedModal) {
    if (!showAddEmbedModal) {
      return null;
    }

    return _react.default.createElement(_EmbedModalV.default, {
      onClose: this.handleCloseModal,
      onSubmit: this.handleAddEmbed
    });
  },
  render: function render() {
    var useUnstyledButton = this.props.useUnstyledButton;
    var showAddEmbedModal = this.state.showAddEmbedModal;

    if (useUnstyledButton) {
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_UIButton.default, {
        onClick: this.handleOpenModal
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "composer-lib.insertTools.embed"
      })), this.renderModal(showAddEmbedModal));
    }

    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_UIButton.default, {
      onClick: this.handleOpenModal,
      size: "small",
      use: "tertiary-light"
    }, _react.default.createElement(_UIIcon.default, {
      name: "code"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.embedPlugin.buttons.embed"
    })), this.renderModal(showAddEmbedModal));
  }
});

exports.default = _default;
module.exports = exports.default;